import { helper } from '@ember/component/helper';

const formatter = new Intl.DateTimeFormat('de-DE', {
  dateStyle: 'medium',
});

export default helper(function displayDate(positional /*, named*/) {
  let date = positional[0];
  if (typeof date === 'string') {
    // If the input is a string, parse it to a Date object
    date = new Date(date);
  }
  return formatter.format(date);
});
